<template>
  <vs-popup
    title="Change Note Required"
    color="warning"
    class="change-notes-popup"
    :active="active"
    @close="cancel"
  >
    <div class="change-notes-popup__content">
      <p>Please add a change note before saving.</p>
      <vs-textarea
        v-model="value"
        class="w-full mt-4 change-notes-popup__textarea"
        height="160px"
      />
      <div class="flex justify-end mt-6">
        <vs-button class="mr-3" type="border" color="dark" @click="cancel">
          Cancel
        </vs-button>
        <vs-button color="primary" :disabled="!trimmedValue" @click="confirm">
          Save
        </vs-button>
      </div>
    </div>
  </vs-popup>
</template>

<script>
export default {
  name: 'ChangeNotesPopup',
  data() {
    return {
      active: false,
      value: '',
      pendingPromise: null,
      resolver: null,
    }
  },
  computed: {
    trimmedValue() {
      return this.value.trim()
    },
  },
  methods: {
    open() {
      if (this.active && this.pendingPromise) {
        return this.pendingPromise
      }

      this.value = ''
      this.active = true

      this.pendingPromise = new Promise((resolve) => {
        this.resolver = resolve
      })

      return this.pendingPromise
    },
    confirm() {
      this.active = false
      const changeNote = this.trimmedValue
      this.value = ''

      if (this.resolver) {
        this.resolver(changeNote)
        this.resolver = null
      }
      this.pendingPromise = null
    },
    cancel() {
      this.active = false
      this.value = ''

      if (this.resolver) {
        this.resolver(null)
        this.resolver = null
      }
      this.pendingPromise = null
    },
  },
}
</script>

<style scoped>
.change-notes-popup__content p {
  margin-bottom: 0;
}

.change-notes-popup__textarea /deep/ textarea {
  height: 160px;
  min-height: 160px;
}
</style>
